import { CustomCell } from '../../components/custom-cell';
import { getNumericOperators } from '../../utils/getNumericOperators';
import { getDateOperators } from '../../utils/getDateOperators';
import { thousandSeparator } from '../reqs-filter/utils';

export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm:ss';

export const TABLE_ORDERS_PLANNINGS_COLUMNS = (groups, configs) => [
	{
		headerName: '#',
		field: 'id',
		width: 100,
		minWidth: 100,
		align: 'center',
		headerAlign: 'center',
		type: 'number',
		cellClassName: 'id',
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Группа',
		field: 'group_id',
		flex: 1,
		type: 'singleSelect',
		valueOptions: groups,
		getOptionValue: value => value?.id,
		getOptionLabel: value => value?.name ?? 'Все',
		valueGetter: (value, row) => {
			if (!row.group) {
				return 0;
			}

			return row.group.id;
		},
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Конфигурация',
		field: 'config_id',
		flex: 1,
		type: 'singleSelect',
		valueOptions: configs,
		getOptionValue: value => value?.id,
		getOptionLabel: value => value?.name ?? 'Все',
		valueGetter: (value, row) => {
			if (!row.config) {
				return '';
			}

			return row.config.id;
		},
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Статус',
		field: 'status_id',
		flex: 1,
		sortable: false,
		filterable: false,
		valueGetter: (value, row) => {
			if (!row.status) {
				return '';
			}

			return row.status.name;
		},
	},
	{
		headerName: 'Кол-во точек',
		field: 'count_orders',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		sortable: false,
		filterable: false,
		valueGetter: (value, row) => {
			if (!row.count_orders || row.count_orders_planned === null) {
				return '---';
			}

			return `${row.count_orders_planned ?? 0}/${row.count_orders ?? 0}`;
		},
	},
	{
		headerName: 'Кол-во маршрутов',
		field: 'count_ways',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(),
		valueGetter: (value, row) => {
			if (row.count_ways === null) {
				return '---';
			}

			return row.count_ways;
		},
	},
	{
		headerName: 'Расходы',
		field: 'cost',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(),
		valueGetter: (value, row) => {
			if (!row.cost) {
				return '---';
			}

			return `${thousandSeparator(row.cost)} руб`;
		},
	},
	{
		headerName: 'Пробег',
		field: 'distance',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(),
		valueGetter: (value, row) => {
			if (!row.distance) {
				return '---';
			}

			return `${thousandSeparator(row.distance, 3)} км`;
		},
	},
	{
		headerName: 'Дата',
		field: 'created_at',
		flex: 1,
		type: 'date',
		filterOperators: getDateOperators(),
		formatter: value => new Date(value).toLocaleDateString('ru-RU'),
		valueGetter: (value, row) => {
			if (!row.created_at) {
				return value;
			}

			return new Date(row.created_at);
		},
	},
	{
		headerName: 'Ссылка',
		field: 'link',
		flex: 1,
		sortable: false,
		filterable: false,
		renderCell: params => CustomCell(params),
	},
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
